import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ICategoryTravel, IGenerateNews, INews, IPartner, IReporter, ITossStock, ITravelPlace, ITravelTag, IWeatherPlace } from "./types/_news";
import { PaginationResponse, ResponseData } from "./types/_public";
import { ITagNews } from "./types/_master";
const api = new APIClient();

const path = '/news';
const path_generate_news = '/generate-news';
const newsApi = {
  aiNews(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  governmentNews(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/government/news`
    return api.get(url, params)
  },
  getNewsKeywords(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/keywords`
    return api.get(url, params)
  },
  news(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>>> {
    const url = `${path}/${id}`
    return api.get(url, params)
  },
  putNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  deleteNewsMulti(dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    })
  },
  downloadNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/download`;
    const TYPE_DOWNLOAD: any = {
      COPY: 1,
      WORD: 2,
      PDF: 3,
      ZIP: 4
    };
    return api.post(url, {
      // news_id: id,
      download_type: TYPE_DOWNLOAD?.[`${params?.type}`] || '',
      language_code: params?.language_code || 'ko',
    })
  },
  downloadExcelNews(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/export`
    return api.get(url, params)
  },
  importMediaMewsByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `/news-trackings/import`;
    const formData = new FormData();
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    if (dataForm.admin_id) {
      formData.append('admin_id', dataForm.admin_id);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getChartRankingKeywordNews(params: any = {}): Promise<AxiosResponse<ResponseData<INews>>> {
    const url = `/news-trackings/chart-v2`
    return api.get(url, params)
  },
  getChartDailySearchVolumeRankingKeywordNews(params: any = {}): Promise<AxiosResponse<ResponseData<INews>>> {
    const url = `/news-trackings/chart-daily-search-volume`
    return api.get(url, params)
  },
  putKeywordNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path}/${id}/keyword`;
    return api.put(url, dataForm)
  },
  putCategoryNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path}/${id}/category`;
    return api.put(url, dataForm)
  },
  putTagNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ITagNews>, any>> {
    const url = `${path}/${id}/tags`;
    return api.put(url, dataForm)
  },
  postNewsTracking(dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `/news-trackings`;
    return api.post(url, dataForm)
  },
  publishNews(id: string | number, data: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/publish`;
    return api.post(url, data);
  },
  unPublishNews(id: string | number, data: any = {}): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/unpublish`;
    return api.post(url, data);
  },
  postPublishUrlNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<INews>, any>> {
    const url = `${path}/${id}/publish-url`;
    return api.post(url, dataForm)
  },
  cancelMyNews(id: string | number, params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `${path}/${id}/cancel-used`
    return api.put(url, params)
  },
  generateNews(params: any): Promise<AxiosResponse<ResponseData<IGenerateNews[]> & PaginationResponse, any>> {
    const url = `${path_generate_news}`
    return api.get(url, params)
  },
  keywordGenerateNews(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<INews>>> {
    const url = `${path_generate_news}/${id}`
    return api.get(url, params)
  },
  postKeywordGenerateNews(dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path_generate_news}`;
    return api.post(url, dataForm)
  },
  putKeywordGenerateNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path_generate_news}/${id}`;
    return api.put(url, dataForm)
  },
  putKeywordReGenerateNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path_generate_news}/${id}/re-generate`;
    return api.put(url, dataForm)
  },
  deleteKeywordGenerateNews(dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `${path_generate_news}`;
    return api.delete(url, {
      data: dataForm
    })
  },
  deleteGenerateNewsMulti(dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `/generate-news`;
    return api.delete(url, {
      data: dataForm
    })
  },
  allPartners(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IPartner>>> {
    const url = `/masters/partners`
    return api.get(url, params)
  },
  allReporters(params: any = {}): Promise<AxiosResponse<ResponseData<IReporter>>> {
    const url = `/masters/reporters`
    return api.get(url, params)
  },

  getAllMediaAdsHub(params: any = {}): Promise<AxiosResponse<ResponseData<IPartner>>> {
    const url = `/masters/ads-hub/medias`
    return api.get(url, params)
  },

  getTemplateSampleNewsExcel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `/masters/news-monitor/templates`
    return api.get(url, params)
  },

  getGenerateBoostingNews(params: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/systems/jobs/status`
    return api.get(url, params)
  },

  postGenerateBoostingNews(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/systems/jobs`;
    return api.post(url, dataForm)
  },

  putGenerateBoostingNews(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/systems/jobs/${id}/status`;
    return api.post(url, dataForm)
  },

  postReCreateVoteKeywordNews(id: string | number, dataForm: any = {}): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/news/${id}/re-create`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getTemplateSampleBoostingNewsExcel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/news-boosting/templates`
    return api.get(url, params)
  },
  importGenerateBoostingNewsByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/news-boosting/import`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getNewsBoostingLogs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/news-boosting/logs`;
    return api.get(url, params)
  },
  getNewsV2s(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/news-v2`
    return api.get(url, params)
  },
  getNewsV2Logs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/news-v2/logs`;
    return api.get(url, params)
  },
  postGenerateBoostingNewsV2(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/news-v2`;
    return api.post(url, dataForm)
  },
  postKeywordGenerateNewsV2(dataForm: any): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `/news-v2/simulator`;
    return api.post(url, dataForm);
  },
  importGenerateBoostingNewsV2ByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/news-v2/import`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getDetailGenerateNewsV2(id: string | number): Promise<AxiosResponse<ResponseData<IGenerateNews>, any>> {
    const url = `/news-v2/simulator/${id}`;
    return api.get(url)
  },
  getTemplateSampleNewsV2Excel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/news-v2/templates`
    return api.get(url, params)
  },
  deleteMultiNewsV2(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    })
  },

  // Travel Weather News

  getNewsTravels(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/travel/news`
    return api.get(url, params)
  },

  getPlaceTravels(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/travel/places`
    return api.get(url, params)
  },

  allCategoryTravel(params: any = {}): Promise<AxiosResponse<ResponseData<ICategoryTravel[]>, any>> {
    const url = `/masters/travel/categories`
    return api.get(url, params)
  },

  allPlaceTravel(params: any = {}): Promise<AxiosResponse<ResponseData<ITravelPlace[]>, any>> {
    const url = `/masters/travel/administrative-agencies`
    return api.get(url, params)
  },

  allTagTravel(params: any = {}): Promise<AxiosResponse<ResponseData<ITravelTag[]>, any>> {
    const url = `/masters/travel/review-tags`
    return api.get(url, params)
  },
  postGenerateNewsTravel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/travel/news`;
    return api.post(url, dataForm)
  },
  getDetailGenerateNewsTravel(id: string | number): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/travel/news/${id}`;
    return api.get(url)
  },
  postSimulatorGenerateNewsTravel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/travel/news/simulator`;
    return api.post(url, dataForm)
  },
  getDetailSimulatorGenerateNewsTravel(id: string | number): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/travel/news/simulator/${id}`;
    return api.get(url)
  },

  getNewsTravelLogs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/travel/news/logs`;
    return api.get(url, params)
  },
  importGenerateTravelNewsByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/travel/news/import`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getTemplateSampleTravelNewsExcel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/travel/templates`
    return api.get(url, params)
  },

  getSummarySelectedPlacesByCategory(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/travel/summary-selected-places-by-category`
    return api.get(url, params)
  },

  getPlaceWeathers(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/weather`
    return api.get(url, params)
  },

  getNewsWeathers(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/weather/news`
    return api.get(url, params)
  },

  getNewsWeatherLogs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/weather/news/logs`
    return api.get(url, params)
  },

  importGenerateWeatherNewsByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/news/import`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  getTemplateSampleWeatherNewsExcel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/weather/templates`
    return api.get(url, params)
  },

  allPlaceWeathers(params: any = {}): Promise<AxiosResponse<ResponseData<IWeatherPlace[]>, any>> {
    const url = `/masters/weather/cities`
    return api.get(url, params)
  },

  getInfoWeather(params: any = {}): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather`;
    return api.get(url, params)
  },

  postGenerateWeatherNews(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/news`;
    return api.post(url, dataForm)
  },

  postGenerateWeatherWarningNews(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/warning/news`;
    return api.post(url, dataForm)
  },

  importGenerateWeatherWarningNewsByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/warning/news/import`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  getTemplateSampleWeatherWarningNewsExcel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/weather/warning/templates`
    return api.get(url, params)
  },

  postSimulatorGenerateNewsWeather(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/news/simulator`;
    return api.post(url, dataForm)
  },
  getDetailSimulatorGenerateNewsWeather(id: string | number): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/news/simulator/${id}`;
    return api.get(url)
  },

  getNewsWeatherWarnings(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/weather/news`
    return api.get(url, params)
  },

  getNewsWeatherWarningLogs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/weather/news/logs`
    return api.get(url, params)
  },

  getInfoWeatherWarning(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/weather/warning`;
    return api.get(url, params)
  },

  postSimulatorGenerateNewsWeatherWarning(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/warning/news/simulator`;
    return api.post(url, dataForm)
  },
  getDetailSimulatorGenerateNewsWeatherWarning(id: string | number): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/weather/news/simulator/${id}`;
    return api.get(url)
  },

  getNewsStocks(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/stock/news`
    return api.get(url, params)
  },

  getNewsStockLogs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/stock/news/logs`
    return api.get(url, params)
  },
  getNewsStockSchedules(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/excel-uploads`
    return api.get(url, params)
  },
  cancelNewsStockSchedule(id: string | number): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/excel-uploads/${id}/cancel-schedule`;
    return api.post(url, {});
  },
  postGenerateNewsStockByToss(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/stock/toss/news`;
    return api.post(url, dataForm);
  },

  getTossStocks(params: any): Promise<AxiosResponse<ResponseData<ITossStock[]> & PaginationResponse, any>> {
    const url = `/stock/toss`
    return api.get(url, params)
  },
  getNewsTossStocks(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/stock/news`
    return api.get(url, params)
  },
  getNewsTossStockLogs(params: any): Promise<AxiosResponse<ResponseData<INews[]> & PaginationResponse, any>> {
    const url = `/stock/news/logs`
    return api.get(url, params)
  },
  getTemplateSampleNewsStockExcel(params: any = {}): Promise<AxiosResponse<ResponseData<any>>> {
    const url = `masters/stock/templates`
    return api.get(url, params)
  },
  importGenerateNewsStockByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/stock/news/import`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  downloadImageNewsStockBulk(params: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/stock/news/images/download`;
    return api.get(url, params);
  },
  postSimulatorGenerateNewsStock(dataForm: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/stock/news/simulator`;
    return api.post(url, dataForm)
  },
  getDetailSimulatorGenerateNewsStock(id: string | number): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/stock/news/simulator/${id}`;
    return api.get(url)
  },
}
export default newsApi
